import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=4931d83b&"
import script from "./NewsOverview.vue?vue&type=script&lang=js&"
export * from "./NewsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports